import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import { useEffect, useState } from 'react'
import * as pri from 'react-bootstrap'
import * as Yup from 'yup';
import {
    allowAlphabetAndSpacesOnly,
    allowAlphabetsNumbersSpacesAndSpecialChars,
    allowNumbersOnly,
    getOutsideDistrict,
    getOutsideMandals,
    getOutsideSecretariatDetails,
    getOutsideVillages,
    OnlyAlphabates,
    OnlyNumbers
} from '../CommonUtils/CommonGetApis'
import { useDispatch, useSelector } from 'react-redux'
import PublicHeaderPanchayat from '../Layout/PublicHeaderPanchayat'
import { CommonAxiosGet } from '../CommonUtils/CommonAxios'
import Swal from 'sweetalert2'
import axios from 'axios'
import { config } from '../CommonUtils/CommonURLS'

import AadhaarAuthentication from '../CommonUtils/CommonCode/AadhaarAuthentication'
import Header from '../Layout/Header';
import { useNavigate } from 'react-router-dom';
import { TbArrowBackUp } from 'react-icons/tb';

function Donations() {
    const dispatch = useDispatch(); const locgov_gen = useSelector((state) => state.reducers?.commonmastersreducer?.locgov);

    const adharmobile_gen = useSelector((state) => state.reducers?.commonmastersreducer?.adharmobile);
    const RoleId = useSelector((state) => state.reducers?.commonmastersreducer?.dualroles);

    const outside_district_gen = useSelector((state) => state.reducers?.commonmastersreducer?.outside_district);
    const outside_mandals_gen = useSelector((state) => state.reducers?.commonmastersreducer?.outside_mandals);
    const outside_secretariats_gen = useSelector((state) => state.reducers?.commonmastersreducer?.outside_secretariats);
    const outside_villages_gen = useSelector((state) => state.reducers?.commonmastersreducer?.outside_villages);
    const verifyStatusadhaar = useSelector((state) => state.reducers?.drillDownReducer?.verifyStatusadhaar);

    const [show, setShow] = useState(false);
    const [getverifyStatus, setverifyStatus] = useState("no");
    const [aadhaarValue, setAadhaarValue] = useState("");

    const [getDonationCategory, setDonationCategory] = useState([])
    const [getGuardianRelation, setGuardianRelation] = useState([])

    const [sectariatlist_gen, setsectariatlist_gen] = useState([])

    const isRoleOne = parseInt(RoleId) === 1;
    console.log("isRoleOne", isRoleOne);
    const panchayatOptions = isRoleOne ? sectariatlist_gen : outside_secretariats_gen;

    const handleClose = () => setShow(false);

    const validation = Yup.object().shape({
        district: Yup.string().when([], {
            is: () => !isRoleOne,
            then: Yup.string().required("District is required"),
            otherwise: Yup.string().nullable()
        }),
        mandal: Yup.string().when([], {
            is: () => !isRoleOne,
            then: Yup.string().required("Mandal is required"),
            otherwise: Yup.string().nullable()
        }),
        panchayat: Yup.string().required('Panchayat is required'),
        p_pin_code: Yup.string().required('Panchayat is required'),

        donar_surname: Yup.string().matches(OnlyAlphabates, 'Allow Only Alphabates').required('Donor surname is required'),
        donar_name: Yup.string().matches(OnlyAlphabates, 'Allow Only Alphabates').required('Donor name is required'),
        gender: Yup.string().required('Gender is required'),
        aadhar_no: Yup.string().matches(OnlyNumbers, 'Allow Only Numbers').required('Aadhar number is required'),

        mobile_no: Yup.string().matches(OnlyNumbers, 'Allow Only Numbers').required('Mobile number is required'),
        guardian_relation: Yup.string().required('Guardian relation is required'),
        guardian_name: Yup.string().matches(OnlyAlphabates, 'Allow Only Alphabates').required('Guardian name is required'),
        door_no: Yup.string().required('Door number is required'),
        donar_address: Yup.string().required('Donor address is required'),

        donation_categorey: Yup.string().required('Donation category is required'),
        purpose: Yup.string().matches(OnlyAlphabates, 'Allow Only Alphabates').required('Purpose is required'),
        amount: Yup.string().matches(OnlyNumbers, 'Allow Only Numbers').required('Amount is required'),
    });

    const formik = useFormik({
        initialValues: {
            district: "",
            mandal: "",
            panchayat: "",
            p_pin_code: "",

            donar_surname: "",
            donar_name: "",
            gender: "",
            aadhar_no: "",
            mobile_no: "",
            guardian_relation: "",
            guardian_name: "",
            door_no: "",
            donar_address: "",

            donation_categorey: "",
            purpose: "",
            amount: "",
        },
        validationSchema: validation,
        onSubmit: () => {
            let payload = {
                p_purposecategory_id: formik?.values?.donation_categorey,
                p_applicant_surname: formik?.values?.donar_surname,
                p_applicant_name: formik?.values?.donar_name,

                p_guardian_id: formik?.values?.guardian_relation,
                p_guardian_name: formik?.values?.guardian_name,
                p_gender_id: formik?.values?.gender,
                p_aadhar_no: formik?.values?.aadhar_no,
                p_mobile_no: formik?.values?.mobile_no,
                p_applicant_address: formik?.values?.donar_address,
                p_secretariat_id: formik?.values?.panchayat,
                district: isRoleOne ? 0 : formik?.values?.district,
                mandal: isRoleOne ? 0 : formik?.values?.mandal,
                p_pin_code: formik?.values?.p_pin_code,
                p_door_no: formik?.values?.door_no,
                p_demand_amount: formik?.values?.amount,
                p_purpose: formik?.values?.purpose,
            }
            axios.post(config.url.API_URL + "citizen-service/insertdonationdetailsinsert", payload).then((res) => {

                if (res?.data?.scode == "01") {

                    let resData = res?.data?.data;
                    const form = document.createElement('form');
                    form.method = 'POST'; form.action = config?.url?.SBI_PAYMENT_URL;
                    const inputmerchantid = document.createElement('input'); inputmerchantid.type = 'hidden';
                    inputmerchantid.name = 'merchant_code'; inputmerchantid.id = 'merchant_code';
                    inputmerchantid.value = "PANCH_CFMS"; form.appendChild(inputmerchantid);

                    const inputencryption = document.createElement('input');
                    inputencryption.type = 'hidden'; inputencryption.name = 'encdata';
                    inputencryption.id = 'encdata'; inputencryption.value = resData;
                    form.appendChild(inputencryption); document.body.appendChild(form); form.submit();
                }
                else if (res?.data?.scode == "02") {
                    Swal.fire(res?.data?.sdesc, "", "info")

                }
                else if (res?.data?.scode == "03") {
                    Swal.fire(res?.data?.sdesc, "", "info")
                }
            })
        }
    })

    useEffect(() => {
        getOutsideDistrict();
        dispatch({
            type: "ADHARMOBILE",
            payload: {}
        });
    }, [dispatch])

    function ClearAll() {
        formik?.setFieldValue("mandal", "")
        formik?.setFieldValue("panchayat", "")
        formik?.setFieldValue("village", "")
    }

    function ClearPanchayatVillage() {
        formik?.setFieldValue("panchayat", "")
        formik?.setFieldValue("village", "")
    }

    function ClearVillage() {
        formik?.setFieldValue("village", "")
    }

    useEffect(() => {
        dispatch({ type: "OUTSIDEDISTRICT", paylod: [] })
        dispatch({ type: "OUTSIDEMANDALS", paylod: [] })
        dispatch({ type: "OUTSIDESECRETARIAT", paylod: [] })
        dispatch({ type: "OUTSIDEVILLAGES", paylod: [] })
    }, [dispatch])

    function getdonationcategoryguardiantype() {
        axios.get(config.url.API_URL + "citizen-service/getdonationcategoryguardiantype").then((res) => {
            if (res?.data?.scode == "01") {
                setDonationCategory(res?.data?.getDonationCategory)
                setGuardianRelation(res?.data?.getGuadianType)
            }
            else if (res?.data?.scode == "02") {
                Swal.fire("res?.datda?.sdesc", "", "info");
            }
            else if (res?.data?.scode == "03") {
                Swal.fire("res?.datda?.sdesc", "", "info");
            }
        })
    }

    const setResponseFromAadharData = () => {
        setverifyStatus("yes");

        const data = adharmobile_gen?.authdata || {};

        formik.setFieldValue("aadhar_no", data.uid || "");

        const nameParts = data.name?.split(" ") || [];
        formik.setFieldValue("donar_surname", nameParts[0] || "");
        formik.setFieldValue("donar_name", data.name || "");

        const guardianName = data.co?.replace(/^[^ ]+\s+/i, "") || "";
        formik.setFieldValue("guardian_name", guardianName);

        const genderMap = { M: "1", F: "2", T: "3" };
        formik.setFieldValue("gender", genderMap[data.gender] || "");

        const donorAddress = [
            data.house,
            data.street,
            data.vtc,
            data.dist,
            data.state,
            data.country,
        ]
            .filter(Boolean)
            .join(", ");
        formik.setFieldValue("donar_address", donorAddress);

        formik.setFieldValue("door_no", data.house || "");
        formik.setFieldValue("p_pin_code", data.pc || "");
    };

    useEffect(() => {
        if (adharmobile_gen?.authdata) {
            setResponseFromAadharData();
        }
    }, [adharmobile_gen]);

    const fetchSecreDetails = async () => {
        try {
            const response = await CommonAxiosGet(`getsecretratedetails`);

            if (response?.data?.scode === "01") {
                setsectariatlist_gen(response?.data?.SecretraitDetails)
            }
        } catch (error) {
            console.log(error);
        }
    }
    const navigate = useNavigate();
    // Common initial setup
    useEffect(() => {
        formik.resetForm();
        getdonationcategoryguardiantype();
        localStorage.setItem('aadhaarVerifyData', JSON.stringify({}));
        dispatch({ type: "AADHAARVERIFIEDDATA", payload: {} });
    }, [dispatch])

    // Fetch secretariat details only for role 1
    useEffect(() => {
        if (isRoleOne) {
            fetchSecreDetails();
        }
    }, [isRoleOne]);

    return (
        <div className={show ? "blur-background" : ""}>
            {!isRoleOne && <PublicHeaderPanchayat />}
            {/* <Header /> */}
            <pri.Modal show={show} onHide={handleClose} size="lg">
                <pri.Modal.Header closeButton className="model-head">
                    <pri.Modal.Title className="model-head-text">
                    </pri.Modal.Title>
                </pri.Modal.Header>
                <pri.Modal.Body><AadhaarAuthentication /></pri.Modal.Body>
                <pri.Modal.Footer>
                    <pri.Button
                        variant="secondary"
                        className="close-button"
                        onClick={handleClose}
                        type="button"
                    >
                        Close
                    </pri.Button>
                </pri.Modal.Footer>
            </pri.Modal>

            <pri.Container fluid style={{ marginTop: "74px" }}>
                <pri.Row>
                    <pri.Col
                        xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}
                        className="page-titlespacing d-flex justify-content-between align-items-center"
                    >
                        <div className="inner-herbpage-service-title1">
                            <h1>Donations</h1>
                        </div>

                        <div className="ms-auto">

                            {/* <button className="btn btn-primary back-button ms-auto" style={{ float: "right" }} onClick={() => navigate("/")} ><TbArrowBackUp className="back-icon" />Back</button> */}

                            <div className="ms-auto">
                                {!isRoleOne &&
                                    <pri.Button
                                        type="button"
                                        className="btn-btn-success back-button"
                                        onClick={() => navigate("/SwarnaPanchayatServices")}
                                    >
                                        <TbArrowBackUp className="back-icon" /> Back
                                    </pri.Button>
                                }

                                {isRoleOne &&
                                    <pri.Button
                                        type="button"
                                        className="btn-btn-success back-button"
                                        onClick={() => navigate("/sidebar")}
                                    >
                                        <TbArrowBackUp className="back-icon" /> Back
                                    </pri.Button>
                                }
                            </div>


                        </div>
                    </pri.Col>
                </pri.Row>
            </pri.Container>


            <pri.Container fluid className="outer-page-content-container">
                <FormikProvider value={formik}>
                    <Form onSubmit={formik?.handleSubmit} onChange={formik?.handleChange}>

                        <pri.Row >
                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                <div>
                                    <h5 className='sub-head' style={{ color: "rgb(105, 45, 30)" }}>Panchayat Details:</h5>
                                </div>
                            </pri.Col>
                        </pri.Row>

                        {/* <pri.Row className="px-2 pt-3 align-items-center">
                            {!isRoleOne && <>
                                <pri.Col xs={12} sm={12} md={5} lg={2} xl={2} xxl={2}>
                                    <label>District <span className="text-danger">*</span></label>
                                </pri.Col>
                                <pri.Col xs={12} sm={12} md={7} lg={4} xl={4} xxl={4} className="mb-2">
                                    <Field as="select" name="district"
                                        className="form-select"
                                        onChange={(e) => { formik.handleChange(e); getOutsideMandals(e.target.value); ClearAll(); }}>
                                        <option value="">-----Select District-----</option>
                                        {outside_district_gen && outside_district_gen?.map((rowdata, index) => (
                                            <option key={rowdata?.district_id} value={rowdata?.district_id}>
                                                {rowdata?.district_desc}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage
                                        name="district" component="div" className="text-danger" />
                                </pri.Col>

                                <pri.Col xs={12} sm={12} md={5} lg={2} xl={2} xxl={2}>
                                    <label>Mandal <span className="text-danger">*</span></label>
                                </pri.Col>
                                <pri.Col xs={12} sm={12} md={7} lg={4} xl={4} xxl={4} className="mb-2">
                                    <Field as="select"
                                        name="mandal" className="form-select"
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            getOutsideSecretariatDetails(formik?.values?.district, e.target.value);
                                            ClearPanchayatVillage();
                                        }}>
                                        <option value="">-----Select Mandal-----</option>
                                        {outside_mandals_gen && outside_mandals_gen.map((rowdata, index) => (
                                            <option key={rowdata?.mandal_id} value={rowdata?.mandal_id}>
                                                {rowdata?.mandal_desc}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage
                                        name="mandal" component="div" className="text-danger" />
                                </pri.Col>
                            </>}

                            <pri.Col xs={12} sm={12} md={5} lg={2} xl={2} xxl={2}>
                                <label>Panchayat <span className="text-danger">*</span></label>
                            </pri.Col>
                            <pri.Col xs={12} sm={12} md={7} lg={4} xl={4} xxl={4} className="mb-2">
                                <Field
                                    as="select"
                                    name="panchayat"
                                    className="form-select"
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                        if (!isRoleOne) {
                                            getOutsideVillages(e.target.value);
                                            ClearVillage();
                                        }
                                    }}
                                >
                                    <option value="">-----Select Panchayat-----</option>
                                    {panchayatOptions && panchayatOptions.map((rowdata, index) => (
                                        <option key={rowdata?.secretariat_id} value={rowdata?.secretariat_id}>
                                            {rowdata?.secretariat_desc}
                                        </option>
                                    ))}
                                </Field>
                                <ErrorMessage name="panchayat"
                                    component="div" className="text-danger" />
                            </pri.Col>
                        </pri.Row> */}



                          <pri.Row className="px-2 pt-3 align-items-center">
                              <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
                                                                <label className='d-block mb-2'>Local Governance:&nbsp;&nbsp; <b className='d-block mt-2' style={{color:"red"}}>{locgov_gen?.loc_gov_name}</b></label>
                                                            </pri.Col>
                                                         
                         {/* <pri.Col xs={12} sm={12} md={12} lg={12} xl={1} xxl={1}></pri.Col> */}
                        
                        
                                                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className='d-block mb-2'>{locgov_gen?.loc_gov_id=="1"?"Panchayat":locgov_gen?.loc_gov_id=="2"?"Mandal":locgov_gen?.loc_gov_id=="3"?"District":""}<span className="text-danger">*</span></label>
                                                                                   
                                                            {locgov_gen?.loc_gov_id=="1"?(<>
                                                                                                 <Field as="select" name="panch_secretariat_id"
                                                            className="form-select"
                                                          
                        
                                                        >
                                                            <option value="">---Select---</option>
                                                            {sectariatlist_gen?.length > 0 &&
                                                                sectariatlist_gen?.map((data, i) => {
                                                                    return (
                                                                        <option value={data?.secretariat_id}>
                                                                            {data?.secretariat_desc}
                                                                        </option>
                                                                    );
                                                                })}
                                                        </Field>
                                                        <ErrorMessage
                                                            name="panch_secretariat_id"
                                                            component="div"
                                                            className="text-danger"
                                                        />
                                                            </>):locgov_gen?.loc_gov_id=="2"?(<>
                                                                                                 <Field as="select" name="panch_secretariat_id"
                                                            className="form-select"
                                                        
                        
                                                        >
                                                            <option value="">---Select---</option>
                                                            <option value="1">Thullur</option>
                                                          
                                                        </Field>
                                                        <ErrorMessage
                                                            name="panch_secretariat_id"
                                                            component="div"
                                                            className="text-danger"
                                                        />
                        
                        
                                                            </>):locgov_gen?.loc_gov_id=="3"?(<>
                                                            
                                                                                                 <Field as="select" name="panch_secretariat_id"
                                                            className="form-select"
                                                         
                        
                                                        >
                                                            <option value="">---Select---</option>
                                                                <option value="1">Guntur</option>
                                                          
                                                        </Field>
                                                        <ErrorMessage
                                                            name="panch_secretariat_id"
                                                            component="div"
                                                            className="text-danger"
                                                        />
                                                            
                                                            </>):""}
                        
                                                            </pri.Col>
                                                            </pri.Row>

                        {/* <pre></pre> */}

                        <pri.Row >
                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                <div>
                                    <h5 className='sub-head' style={{ color: "rgb(105, 45, 30)" }}>Donor Details:</h5>
                                </div>
                            </pri.Col>
                        </pri.Row>

                        <pri.Row className="px-2 pt-3 align-items-center">
                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className="d-block mb-2 form-label mb-0">Aadhaar No<span className="text-danger">*</span></label>
                                        
                                <Field name="aadhaarNo">
                                    {({ field }) => (
                                        <input
                                            type="text"
                                            {...field}
                                            placeholder="Enter Aadhaar"
                                            className="form-control"
                                            disabled={getverifyStatus === "yes"}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                setAadhaarValue(val);
                                            }}
                                        />
                                    )}
                                </Field>
                                <ErrorMessage
                                    name="aadhaarNo" component="div" className="text-danger" />
                            </pri.Col>
                            {/* <pri.Col xs={12} sm={12} md={7} lg={4} xl={4} xxl={4} className="mb-2"></pri.Col> */}
                            <pri.Col xs={12} sm={3} md={2} lg={2} xl={2} xxl={2} className='mt-2 mt-sm-0'>
                                <button type="button"
                                    className={getverifyStatus === "yes" ? "btn btn-success btn-sm px-4" : "btn btn-warning btn-sm px-4"}
                                    onClick={() => {
                                        if (!aadhaarValue || aadhaarValue.length !== 12) {
                                            Swal.fire("Please enter a valid 12-digit Aadhaar Number", "", "info"); return;
                                        }
                                        dispatch({ type: "ADHAARVALIDSTATUS", payload: "" });
                                        setShow(true);
                                        dispatch({
                                            type: "AADHAARNUMAUTH", payload: aadhaarValue
                                        });
                                        dispatch({
                                            type: "ADHAARFEILDACTIVESTEP",
                                            payload: { aadhaarNo: aadhaarValue, activeStep: 0 },
                                        });
                                    }}
                                    disabled={getverifyStatus === "yes"}
                                >
                                    {getverifyStatus === "yes" ? "Verified" : "Verify"}
                                </button>
                            </pri.Col>
                        </pri.Row>
                        <pri.Row className="px-2 pt-3 align-items-center">
                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className='d-block mb-2'>
                                    Donor Surname <span className="text-danger">*</span>
                                </label>
                                
                                <Field
                                    type="text"
                                    name="donar_surname"
                                    disabled={true}
                                    placeholder="Surname"
                                    className="form-control"
                                    maxLength="120"
                                    onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }}
                                />
                                <ErrorMessage name="donar_surname" component="div" className="text-danger" />
                            </pri.Col>

                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className='d-block mb-2'>
                                    Donor Name<span className="text-danger">*</span>
                                </label>
                                <Field
                                    type="text"
                                    name="donar_name"
                                    placeholder="Name"
                                    disabled={true}
                                    className="form-control"
                                    maxLength="150"
                                    onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }}
                                />
                                <ErrorMessage name="donar_name" component="div" className="text-danger" />
                            </pri.Col>
<pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className='d-block mb-2'>
                                    Gender <span className="text-danger">*</span>
                                </label>
                                
                                <Field as="select" className="form-select" name="gender" disabled={true}>
                                    <option value="">---Select---</option>
                                    <option value="1">Male</option>
                                    <option value="2">Female</option>
                                    <option value="3">Transgender</option>
                                </Field>
                                <ErrorMessage name="gender" component="div" className="text-danger" />
                            </pri.Col>
                            {/* </pri.Row>
                        <pri.Row className="px-2 pt-3 align-items-center"> */}
                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className='d-block mb-2'>
                                    PinCode <span className="text-danger">*</span>
                                </label>
                                <Field
                                    type="text"
                                    name="p_pin_code"
                                    disabled={true}
                                    placeholder="Enter Pincode"
                                    className="form-control"
                                    maxLength="6"
                                />
                                <ErrorMessage name="p_pin_code" component="div" className="text-danger" />
                            </pri.Col>

                           <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className='d-block mb-2'>
                                    Mobile Number <span className="text-danger">*</span>
                                </label>
                                <Field
                                    type="text"
                                    name="mobile_no"
                                    placeholder="Mobile Number"
                                    className="form-control"
                                    maxLength="10"
                                    onKeyPress={(e) => { allowNumbersOnly(e) }}
                                />
                                <ErrorMessage name="mobile_no" component="div" className="text-danger" />
                            </pri.Col>

                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className='d-block mb-2'>
                                    Door No <span className="text-danger">*</span>
                                </label>
                                <Field
                                    type="text"
                                    name="door_no"
                                    className="form-control"
                                    maxLength="50"
                                    placeholder="Door No"
                                    disabled={true}
                                    onKeyPress={(e) => { allowAlphabetsNumbersSpacesAndSpecialChars(e) }}
                                />
                                <ErrorMessage name="door_no" component="div" className="text-danger" />
                            </pri.Col>
                            {/* </pri.Row>
                        <pri.Row className="px-2 pt-3 align-items-center"> */}
                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className='d-block mb-2'>
                                    Guardian Name <span className="text-danger">*</span>
                                </label>
                                <Field
                                    type="text"
                                    name="guardian_name"
                                    className="form-control"
                                    maxLength="200"
                                    placeholder="Guardian Name"
                                    disabled={true}
                                    onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }}
                                />
                                <ErrorMessage name="guardian_name" component="div" className="text-danger" />
                            </pri.Col>

                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className='d-block mb-2'>
                                    Guardian Relation <span className="text-danger">*</span>
                                </label>
                                <Field
                                    as="select"
                                    name="guardian_relation"
                                    className="form-select"
                                    onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }}
                                    maxLength="100"
                                >
                                    <option>---Select---</option>
                                    {getGuardianRelation && getGuardianRelation.map((rowdata, index) => (
                                        <option key={rowdata?.guardian_id} value={rowdata?.guardian_id}>
                                            {rowdata?.guardian_desc}
                                        </option>
                                    ))}
                                </Field>
                                <ErrorMessage name="guardian_relation" component="div" className="text-danger" />
                            </pri.Col>

                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className='d-block mb-2'>
                                    Donor Address <span className="text-danger">*</span>
                                </label>
                                <Field
                                    as="textarea"
                                    rows="3"
                                    cols="50"
                                    name="donar_address"
                                    className="form-control"
                                    maxLength="500"
                                    placeholder="Donor Address"
                                    disabled={true}
                                    onKeyPress={(e) => { allowAlphabetsNumbersSpacesAndSpecialChars(e) }}
                                />
                                <ErrorMessage name="donar_address" component="div" className="text-danger" />
                            </pri.Col>
                        </pri.Row>

                        {/* <pre></pre> */}

                        <pri.Row >
                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                <div>
                                    <h5 className='sub-head' style={{ color: "rgb(105, 45, 30)" }}>Donation Details:</h5>
                                </div>
                            </pri.Col>
                        </pri.Row>

                        <pri.Row className="px-2 pt-3 align-items-center">
                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className='d-block mb-2'>
                                    Donation Category  <span className="text-danger">*</span>
                                </label>
                                <Field as="select" name="donation_categorey" className="form-select">
                                    <option value="">-----Select Donation Category-----</option>
                                    {getDonationCategory && getDonationCategory.map((rowdata, index) => (
                                        <option key={rowdata?.purposecategory_id} value={rowdata?.purposecategory_id}>
                                            {rowdata?.purposecategory_desc}
                                        </option>
                                    ))}
                                </Field>
                                <ErrorMessage name="donation_categorey" component="div" className="text-danger" />
                            </pri.Col>

                            {/* <pri.Col xs={12} sm={12} md={5} lg={2} xl={2} xxl={2}></pri.Col> */}

                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className='mb-3'>
                                        <label className='d-block mb-2'>
                                    Amount (Rs)<span className="text-danger">*</span>
                                </label>
                                
                                <Field
                                    type="text"
                                    name="amount"
                                    className="form-control"
                                    maxLength="12"
                                    placeholder="Amount"
                                    onKeyPress={(e) => { allowNumbersOnly(e) }}
                                />
                                <ErrorMessage name="amount" component="div" className="text-danger" />
                            </pri.Col>
                            </pri.Row>
                        <pri.Row className="px-2 pt-3 align-items-center">
                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className='mb-3'>
                                        <label className='d-block mb-2'>
                                    Purpose of Donation<span className="text-danger">*</span>
                                </label>
                                <Field
                                    as="textarea"
                                    name="purpose"
                                    className="form-control"
                                    placeholder="Purpose of Donation"
                                    rows="3"
                                    cols="50"
                                    onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }}
                                />
                                <ErrorMessage name="purpose" component="div" className="text-danger" />
                            </pri.Col>
                        </pri.Row>

                        {/* <pre></pre> */}

                        <pri.Row>
                            <pri.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex justify-content-end">
                                <button className="btn btn-primary proceed-to-payment" type="submit">
                                    Proceed for Payment
                                </button>
                            </pri.Col>
                        </pri.Row>

                    </Form>
                </FormikProvider>
            </pri.Container>

        </div>
    )
}

export default Donations
